import React from 'react';

import Hardware from './hardware';
import { PageContext } from '../context/page-context';

function chunkArray(myArray, chunk_size) {
  let index = 0;
  const arrayLength = myArray.length;
  const tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
      const myChunk = myArray.slice(index, index+chunk_size);
      // Do something if you want with the group
      tempArray.push(myChunk);
  }

  return tempArray;
}

class HardwareRecommended extends React.Component {
  render() {
    const {
      content: {
        hardware,
      }
    } = this.props.block;

    let {
      geolocation
    } = this.context;

    if (geolocation === 'Unknown') {
      geolocation = 'ROW';
    }

    const locationSpecificHardware = [];
    hardware.map((ware) => {
      if (ware.acf.region.includes(geolocation)) {
        locationSpecificHardware.push(ware);
      }
    });


    const rows = chunkArray(locationSpecificHardware, 3);

    return (
      <div className="container">
        {rows.map((row, k) => (
          <div className="row" key={k}>
            {row.map((item, k) => <Hardware layout="portrait" key={k} block={item} />)}
          </div>
        ))}
      </div>
   );
  }
}

HardwareRecommended.contextType = PageContext;
export default HardwareRecommended;
